import React from 'react'
import CardImg from '../../assets/img/virtual.png';
import { Link } from 'react-router-dom';
import LayerImg from '../../assets/img/Layer_1.png';
import Img3 from '../../assets/img/image3.png';
import empowerImg from '../../assets/img/empower.png'
import AboutIcon from '../../assets/img/logo/favicon.png';
import { Helmet } from "react-helmet-async";

function VirtualCard() {
  const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
  return (
    <>
      <Helmet>
        <title>Virtual Cards | Cardplot</title>
        <meta name="description" content="Cardplot Virtual Cards are designed to make payments from Lagos to Accra or shopping online in South-Africa with ease." />
      </Helmet>
      <section className='breadcrumb__section__02 padding__tb__100'>
        <div className="container">
          <div className='row'>
            <div className='col-md-12'>
              <div className="breadcrumb__title__head">
                <ol className="breadcrumb">
                  <li className="active"><img src={AboutIcon} style={{ width: '25px', height: '25px' }} alt="" /></li>
                </ol>
                <h2 className='breadcrumb__title'> FEATURES </h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="breadcrumb__text">
                <h3 className='breadcrumb__text__head'>Virtual Cards</h3>
                <p className='breadcrumb__text__content '>
                  Imagine making payments from Lagos to Accra or shopping online in South- Africa with the same ease. Cardplot’s Virtual Cards eliminate the barriers of traditional financial systems, giving you the freedom to interact with the global economy while staying deeply rooted in Africa’s vibrant culture.
                </p>
              </div>
              <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                <Link to='' className='btn btn__primary'>Get Card</Link>
                <Link to='/contact' className='btn btn__outline_primary '>Contact us</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='virtual__section padding__tb__100'>
        <div className='container'>
          <div className='row justify-content-center align-items-center' style={{ paddingBottom: '100px' }}>
            <div className='col-12 col-md-6 mb-4 mb-lg-0 '>
              <div className='virtual__section__content'>
                <p>
                  Cardplot’s Virtual Cards offer a secure and efficient way to make online payments, tailored for personal or business use.
                </p>
                <a className='btn btn__primary mt-4' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                    Get Started
                </a>
              </div>
            </div>
            <div className='col-12 col-md-6 mb-4 mb-lg-0 '>
              <div className=''>
                <img src={CardImg} className='img-fluid' alt='virtual cards' />
              </div>
            </div>
          </div>
          <div className='row  justify-content-center align-items-center'>
            <div className='col-12 col-md-6 mb-4 mb-lg-0 order-2 order-md-1'>
              <div className='virtual__section__image'>
                <img src={LayerImg} className='img-fluid' alt='virtual cards' />
              </div>
            </div>
            <div className='col-12 col-md-6 mb-4 mb-lg-0 order-1 order-md-2'>
              <div className='virtual__section__content'>
                <p>
                  Cardplot’s Virtual Cards offer a secure and efficient way to make online payments, tailored for personal or business use.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='virtual__section__empowering padding__tb__50'>
        <div className='container'>
          <div className='row justify-content-center align-items-center'>
            <div className='col-12 col-md-6 mb-4 mb-lg-0'>
              <div className='virtual__section__content'>
                <p>
                  Empowering students, entrepreneurs, and families to seamlessly manage payments and access global opportunities.
                </p>
                <a className='btn btn__primary mt-4' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                  Get Started
                </a>
              </div>
            </div>
            <div className='col-12 col-md-6 mb-4 mb-lg-0 '>
              <div className='virtual__section__image'>
                <img src={Img3} className='img-fluid' alt='virtual cards' />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='create__virtual__card__section padding__tb__50'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='position-relative'>
                <h2 className='create__virtual__card__section__title'>How to create Virtual Card</h2>
              </div>
            </div>
          </div>
          <div className='create__virtual__card__section__content' style={{ paddingTop: '100px', }}>
            <div className='create__virtual__card__section__content__item'>
              <div className='create__virtual__card__section__content__item__box mb-4'>
                <div className='create__virtual__card__section__content__item__box__icon'>
                  1
                </div>
                <div className='create__virtual__card__item'>
                  <h4>Log into your Account</h4>
                  <p>You may access your Cardplot dashboard using the app or website.</p>
                </div>
              </div>
              <div className='create__virtual__card__section__content__item__box mb-4'>
                <div className='create__virtual__card__section__content__item__box__icon'>
                  2
                </div>
                <div className='create__virtual__card__item'>
                  <h4>Go to Virtual Card</h4>
                  <p>Select "Virtual Cards" and click "Create New Card."  </p>
                </div>
              </div>
              <div className='create__virtual__card__section__content__item__box mb-4'>
                <div className='create__virtual__card__section__content__item__box__icon'>
                  3
                </div>
                <div className='create__virtual__card__item'>
                  <h4>Customize your card</h4>
                  <p>Select the preferred currency, establish spending restrictions, and name the card.</p>
                </div>
              </div>
              <div className='create__virtual__card__section__content__item__box mb-4'>
                <div className='create__virtual__card__section__content__item__box__icon'>
                  4
                </div>
                <div className='create__virtual__card__item'>
                  <h4>Confirm and Activate</h4>
                  <p>Review your information, confirm the creation, and begin using your virtual card immediately.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className='empower_your_trade overlay'>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
              <div className="empower__title">
                <h2>Ready to simplify your payments?</h2>
                <p>Simplify Your Exchange, Empower Your Trade</p>
                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                  <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                    Get Started
                  </a>
                  <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                </div>
              </div>
            </div>
            <div className="col-12 col-lg-6 mb-4 mb-lg-0">
              <div className="empower__img">
                <img src={empowerImg} className='img-fluid' alt="empower" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default VirtualCard